export default (message, image, orgColors) => `
<style>
@import url("https://fonts.googleapis.com/css?family=Raleway");
@import url("https://fonts.googleapis.com/css?family=Open+Sans");

input:focus {outline:0;} 
textarea:focus {outline:0;} 
button:focus {outline:0;} 
select:focus {outline:0;} 
a{
  color: ${orgColors ? orgColors.linkColor : '#27bbed'} !important;
}
.hyraf-twitter-share-form{
  max-width:600px;
  width:100%;
  margin: auto;
  background: white;
  margin-top:140px;
}
.hyraf-twitter-share-form-header{
  height: 80px;
  background:${orgColors ? orgColors.buttonBackgroundColor : '#27bbed'};
  color:${orgColors ? orgColors.buttonFontColor : 'white'};
  border:${orgColors ? orgColors.buttonBorderColor : '#27bbed'};
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  padding:0 20px;
}
.hyraf-twitter-share-form-header span{
  font-size: 24px;
  color: white;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  display:flex;
  align-items:center;
}
.hyraf-twitter-share-form-header .close-btn{
  background:transparent;
  border:none;
  font-size: 30px;
  color:white;
  font-weight: 100;
}

.hyraf-twitter-share-form .content{
  padding:20px 20px 30px 20px;
  border: 1px solid #DADADA;
  border-top:none;
}

.hyraf-twitter-share-form .content .content-heading{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}

.hyraf-twitter-share-form .content .content-subheading{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin-top:30px;
}

.hyraf-twitter-share-form .content .content-label{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgba(51, 51, 51, 0.75);
  margin-top:30px;
}

.hyraf-twitter-share-form .content .content-small-label{
  margin-top:30px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}

.hyraf-twitter-share-form .content input{
  border: none;
  border-bottom: 1px solid #dadada;
  width: 100%;
  margin-top: 20px;
}

.hyraf-twitter-share-form .content textarea{
  border: 1px solid #dadada;
  width: 100%;
  margin-top: 10px;
  height:150px;
}


.hyraf-twitter-share-form .content .submit-btn{
  width: 240px;
  height: 48px;
  background:${orgColors ? orgColors.buttonBackgroundColor : '#27bbed'};
  color:${orgColors ? orgColors.buttonFontColor : 'white'};
  border:${orgColors ? orgColors.buttonBorderColor : '#27bbed'};
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  cursor:pointer;
}
.hyraf-twitter-share-form .footer{
  text-align: right;
  margin-top: 20px;
}
.hyraf-copy-link{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #999999;
  justify-content:space-between;
  border:1px solid #eeeeee;
  height:35px;
  margin-top:10px;
  padding-left:10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.hyraf-copy-link button{
  height: 35px;
  border: none;
  background: transparent;
  width: 80px;
  border-left: 1px solid #eeeeee;
  color: #333333;
  cursor:pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  font-family: "Open Sans", sans-serif;
}

.share-buttons-queue{
  display:flex;
  justify-content:space-between;
  margin-top:10px;
}

.share-buttons-queue button{
  width: 100px;
  height: 86px;
  background: #F9F9F9;
  border-radius: 10px;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor:pointer;
}
.share-buttons-queue button span{
  margin-top:10px;
  color:#333333;
}
.copied-btn{
  background: #66D184 !important;
  box-shadow: inset 1px 0px 0px #DADADA;
  color:white !important;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.copied-btn svg{
  display:block !important;
}
.copy-btn svg{
  display:none;
} 
.share-form-field .guide{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #999999;
}
.share-form-field label {
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}

.mt-20{
  margin-top:20px;
}
@media only screen and (max-width: 480px) {
  .hyraf-twitter-share-form-header{
    height: 60px;
  }
  .hyraf-twitter-share-form-header span{
    font-size: 18px;
  }
  .hyraf-twitter-share-form-header .close-btn{
    right: 10px;
    font-size:25px;
  }
  .hyraf-twitter-share-form .content .content-heading{
    font-size: 16px;
    line-height: 20px;
  }

  .share-buttons-queue{
    display: grid;
    justify-content: space-between;
    margin-top: 10px;
    gap: 10px;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }
  .share-buttons-queue button{
    width:auto;
    height: 44px;
    background: #F9F9F9;
    border-radius: 10px;
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .share-buttons-queue button span{
    margin-top:0;
    margin-left:5px;
  }
  .hyraf-copy-link{
    font-size: 12px;
  }
  .hyraf-twitter-share-form .footer{
    text-align: center;
  }
  .twitter-post .post-content {
    width: calc(100% - 40px)!important;
  }
  .mini-buttons button{
    font-size:12px !important;
    text-align:left;
  }
  .mini-buttons img{
    width:11px !important;
  }
}

.twitter-post{
  border: 1px solid #DADADA;
  border-radius: 10px;
  margin:auto;
  padding:20px;
}

.twitter-post .item{
  display:flex;
}
.twitter-post .item p{
  background: #e4e6ea;
  width: 48px;
  height: 45px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  border-radius: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  align-items:center;
  justify-content:center;
  margin-right:14px;
  margin-top:-10px;
  margin-left:-10px;
}

.twitter-post .item span{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  color: #000000;
  margin-right: 14px;
}

.twitter-post .message{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #000000;
  max-width:467px;
}

.twitter-post .message a{
  word-break: break-all;
}

.twitter-post .post-image{
  width: 100%;
  margin-top:20px;
  border-radius:20px;
}

.twitter-post .post-content{
  width:100%;
}

.mini-buttons{
  display:flex;
  align-items:center;
  margin-top:10px;
}

.mini-buttons button{
  background: transparent;
  border: none;
  color: #6e6a6a;
  display:flex;
  align-items:center;
}

.mini-buttons :nth-child(2){
  margin-left:40px;
}

.mini-buttons button img{
  width:15px;
  margin-top: 0px;
  margin-right:5px;
}

.light-blue-text{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color:${orgColors ? orgColors.buttonBackgroundColor : '#27bbed'};
  display:flex;
  align-items:flex-end;
  background: transparent;
  border: none;
  margin-top:10px;
}
.light-blue-text path {
  fill:${orgColors ? orgColors.buttonBackgroundColor : '#27bbed'} !important;
}

</style>

<meta property="og:image" content="https://farm6.staticflickr.com/5510/14338202952_93595258ff_z.jpg">
<meta property="og:title" content="SOME TEXT">
<meta property="og:description"SOME DESCRIPTION">
<meta name="twitter:site" content="THIS IS CONTENT">
<meta name="twitter:card" content="photo" />
<meta name="twitter:title" content="TWITTER CONTENT">
<meta name="twitter:description" content="TWITTER DESCRIPTION">
<meta name="twitter:image" content="https://farm6.staticflickr.com/5510/14338202952_93595258ff_z.jpg">

<div class="hyraf-twitter-share-form">
  <div class="hyraf-twitter-share-form-header">
    <button class="close-btn"  type="button" onclick="closeSocialPreview('twitter-popup')">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.5 12.5H2.5" stroke="white" stroke-miterlimit="10"/>
        <path d="M9.5 19.5L2.5 12.5L9.5 5.5" stroke="white" stroke-miterlimit="10" stroke-linecap="square"/>
      </svg>
    </button>
    <span class="title">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.953 4.57003C23.0545 4.96563 22.1026 5.22677 21.128 5.34503C22.1541 4.72828 22.9224 3.76107 23.291 2.62203C22.34 3.17703 21.286 3.58103 20.164 3.80603C19.4238 3.01446 18.4429 2.48945 17.3736 2.31253C16.3044 2.13561 15.2067 2.31668 14.2509 2.82762C13.2952 3.33856 12.5349 4.15078 12.0881 5.13815C11.6412 6.12552 11.533 7.2328 11.78 8.28803C7.69 8.09503 4.067 6.13003 1.64 3.16203C1.19879 3.91184 0.968664 4.76705 0.974 5.63703C0.974 7.34703 1.844 8.85003 3.162 9.73303C2.38086 9.70816 1.61697 9.49696 0.934 9.11703V9.17703C0.933557 10.3134 1.32627 11.415 2.04551 12.2948C2.76474 13.1746 3.76621 13.7785 4.88 14.004C4.1583 14.1974 3.40241 14.2265 2.668 14.089C2.98412 15.067 3.59766 15.922 4.42301 16.5345C5.24837 17.1471 6.24435 17.4867 7.272 17.506C5.53153 18.872 3.38248 19.6133 1.17 19.611C0.78 19.611 0.391 19.588 0 19.544C2.25571 20.9884 4.87851 21.755 7.557 21.753C16.61 21.753 21.555 14.257 21.555 7.76803C21.555 7.55803 21.555 7.34803 21.54 7.13803C22.506 6.44289 23.3392 5.57985 24 4.59003L23.953 4.57003Z" fill="#FFFFFF"/>
      </svg>

      &nbsp;
      Twitter
    </span>
    <button class="close-btn"  type="button" onclick="closeSocialPreview('twitter-popup', 'true')">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 5L5 19" stroke="white" stroke-miterlimit="10" stroke-linecap="square"/>
        <path d="M19 19L5 5" stroke="white" stroke-miterlimit="10" stroke-linecap="square"/>
      </svg>
    </button>
  </div>
  <div class="content">

    <div class="twitter-post">
      <div class="item">
        <p>R</p>
        <div class="post-content">
          <div id="twiteer-message-content" class="message">
          ${message}<br/><br/>
          </div>

          <input id="twitter-input" type="hidden" value="\n"/>
       <!--   <img id="twitter-post-image" class="post-image" alt="property" src="${image}"/>-->
          <div class="mini-buttons">
            <button  type=""button >
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAiCAIAAADH6v4jAAAAA3NCSVQICAjb4U/gAAAAEHRFWHRTb2Z0d2FyZQBTaHV0dGVyY4LQCQAABKRJREFUSMfFlttPG0cUxmf2vuv1ddfr2BsImICDgYaEBmiUh6pS/+iqlZpLm0a5AHFCwDYQMI7xjbXXGK/3NqcPrYgtEWIjpT2vq/nNnE/n+85iAEDfpij0zYq5+rPredXa6WGpWq+3XM/lWFZTI5m5W3E1+lU0/pIgAGAYnRev3h8cVhrNVs/qE59QDB2UpdQNNZuZXv0+yzA0xnjsV591e0+eb7x5k+9avbgaTSVVhmVc220Y7a13xUazzQvcd4szHMuOgQaAvu3ki0dPnm2yHP3D6mI2k1bVCMcwtuNW66evt3be5oq/P30djQQndY3l2DHQhtF5+27Pdb35O9OP1u+mkhpF/du4Fo8FJLFRb1VOmju7H+OxyJfQl0yIT0i7c7ZbOAwGA2srWUWJXHARQjRN3Ugoaw8Wer1+Yb/U7fVGHT4AcF3PbHfb7TNZFtNTuijwQwcoHAnLt9MTgMAwOpZtE0JGRVuW3Wp3OJ7TdY1m6UuP8Tyn6xoBqDdaVt/+ry3zf6CBgGt7iFxuKEKI67hAYAw0pihJEhQljChoNFuNU9Pz/aErEerbTq1mtM0uL7BKNMzz3EhzjRHiWDauxm4mE7X66R8vtubnphJqlBd5CmNCoNezypXGVq4IBCb0RCQcZGh61AwBgLNu79XGh19+feG6fkKLJbSYJAs0pnxCzntW+VO93mhN6NrPP61lZicDkjhePJlm97fHLwt7JbNz7jiO6/kAgDGmKVqUeC0eXb2fXV1ZYFlm7ORDCPk+MVrmYemkWjMsy/bAZ2lalqVJXZuaTAUC4jVDdVAfAnBhOYwxTVFXZOmoq4AQ6Fn9U8PsWw5CCGMkCryWiPEce02075NGs/X42Ua+cFitG47jfm4TY4Hnp6dTD1eXFrJpOSANhtdVgnieX67U/3r5Prdd7JjnrufRFBWNhSRJQAgRAOu832i0GJYReV7TYiv3MyvLd5Ro+Co0AOr37fxe6emfm/sHn3zfT6f12fTE1GQyFJIwphBCgMDzfNPs7h0c7+QPm822HAxkM1NrKwvpaZ1h6EsEAYCeZe/mj54+3zg6rgaDwg+rS3Ozt5RIKBgMDE4YALiuqyfV2ZmJ7d2PW7lC7v2eY3uAUGZ28hK05/mVk0buQ/G4XE8m1IfrS0vZ25GwfEmbGHMcl9AUJRZRlUhAErZyxcJ+SZT4oCylkuoQmgB0uue7+aP9vXI0Glx/sLD+YIll6K8MAEPrSU3gOQpTrzd3C8UjVQkrSojnuM/x5Ht+tWbsH5Ytx1lemru/fOer3IuNE4uG7i1nbs/c7J5bO/mjyklzKPn6trN/cGwYnenJ1HxmKihLo4cyTdOaGl2cn04l47W6USiWhtCO45YrjU73PB6P6ANijVgcy+gpLaHFTPPs+FN9CA2AXNcjBASBE0Vh7G1CUZIoiiLveb49YC4GIURTOCCJxCdPnm2+2z7gWGYsNBDo247ZOeN5dlBMBiEky9Kjh3f7tr394aB8bAEe79UYIQSIF9jFhZkfH90bcuM/f2KnhlmtNVvts2tsWJqiQiH5ZkpTlciFJweNDo7r9S37GmhMYY5jheEl+Tc2x2JGYTgxUAAAAABJRU5ErkJggg=="/>
              Tag People
            </button> 
            <button  type=""button >
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAgCAIAAAAT2oadAAAAA3NCSVQICAjb4U/gAAAAEHRFWHRTb2Z0d2FyZQBTaHV0dGVyY4LQCQAAAm9JREFUSMft11tPE0EUAODtzmVnr3S7XXovVylYMSBIjA/ygL/AhN9o/Av6oIkvmqgxIaAxSm2lbEtZS6F2bzO7PhBfROPioomG+QHnm5w5Z+ZMKooijuMYCx3HHX5xgoBxiRfGUJZFkQgA8BzHQY7jRo7bbFnbbxtWx6YXYSAMy0Xz6sJ0tZQjBEPGWPeg/+r1u63t967vIwSTG4FP960epaEiifm8AT0/6BzYrXYHInBr6Vq5OJ7caDT3d940mp+s2ZmyYYxBxkLP86Mw0nV1sT5br00lNySJtK0eZcxxXBpQnvvz638xflxFjuM1mvutva7v+XGiEBFPVovVSp4IOK7xsWU9efpyt9F2vSCmMTdbvbt+c3qqFNfIZLT52qSmyn5A4xgCxhOVfDqtniNXmbS2fL02f2WCsVhtn+J5WSKqIp3DQAjqaVX/yb7+nbpyPb9/dDwcuiEL40QBgFdkUU+rAoldV3vt3qPHz7d3dh3HjWMosrRyY2FjfbVUNOMaooCz+lg2mx6NYhkSERSJQADOkatSydy8t7F5eV/FyNXIcS3Ltj8PAkrPHK9YKpi6rp2+1b9vdLr2sxdbzVbX94Oz88Cd28trq/WkhoCRIouSJAD4fSAiYIzRBeTKNPW11frMdDk4cyeKIsmPGwiCpAZGqJDLFnLZy9r92/0hYKSpEg9SH3bb9x881DQ5edD+0clgcDI3VzUyY4QIECM0USmsLC14XmB1Dnt2P7kB+FSlnF9arJmmDgCfiqKIUjY4HvYO+4f2keN6FzIn5sYN09AVmQAAUqd/Ay7iaMg8L6DxhoRfzO0QYgHBbz30FRmV7Xw1ly8DAAAAAElFTkSuQmCC"/>
              Add Description
            </button>
          </div>
          <button type="button" class="light-blue-text">
            <svg width="15" height="15" x="0" y="0" viewBox="0 0 48.625 48.625" style="enable-background:new 0 0 20 20" class=""><g>
              <g>
                <g>
                  <polygon points="35.432,10.815 35.479,11.176 34.938,11.288 34.866,12.057 35.514,12.057 36.376,11.974 36.821,11.445     36.348,11.261 36.089,10.963 35.7,10.333 35.514,9.442 34.783,9.591 34.578,9.905 34.578,10.259 34.93,10.5   " fill="#27bbed" data-original="#000000" style="" class=""/>
                  <polygon points="34.809,11.111 34.848,10.629 34.419,10.444 33.819,10.583 33.374,11.297 33.374,11.76 33.893,11.76   " fill="#27bbed" data-original="#000000" style="" class=""/>
                  <path d="M22.459,13.158l-0.132,0.34h-0.639v0.33h0.152c0,0,0.009,0.07,0.022,0.162l0.392-0.033l0.245-0.152l0.064-0.307    l0.317-0.027l0.125-0.258l-0.291-0.06L22.459,13.158z" fill="#27bbed" data-original="#000000" style="" class=""/>
                  <polygon points="20.812,13.757 20.787,14.08 21.25,14.041 21.298,13.717 21.02,13.498   " fill="#27bbed" data-original="#000000" style="" class=""/>
                  <path d="M48.619,24.061c-0.007-0.711-0.043-1.417-0.11-2.112c-0.225-2.317-0.779-4.538-1.609-6.62    c-0.062-0.155-0.119-0.312-0.185-0.465c-1.106-2.613-2.659-4.992-4.56-7.045c-0.125-0.134-0.252-0.266-0.379-0.396    c-0.359-0.373-0.728-0.737-1.11-1.086C36.344,2.402,30.604,0,24.312,0C17.967,0,12.186,2.445,7.852,6.44    C6.842,7.371,5.914,8.387,5.072,9.475C1.896,13.583,0,18.729,0,24.312c0,13.407,10.907,24.313,24.313,24.313    c9.43,0,17.617-5.4,21.647-13.268c0.862-1.682,1.533-3.475,1.985-5.354c0.115-0.477,0.214-0.956,0.3-1.441    c0.245-1.381,0.379-2.801,0.379-4.25C48.625,24.228,48.62,24.145,48.619,24.061z M44.043,14.344l0.141-0.158    c0.185,0.359,0.358,0.724,0.523,1.094l-0.23-0.009l-0.434,0.06V14.344z M40.53,10.102l0.004-1.086    c0.382,0.405,0.75,0.822,1.102,1.254l-0.438,0.652l-1.531-0.014l-0.096-0.319L40.53,10.102z M11.202,7.403V7.362h0.487    l0.042-0.167h0.797v0.348l-0.229,0.306h-1.098L11.202,7.403L11.202,7.403z M11.98,8.488c0,0,0.487-0.083,0.529-0.083    s0,0.486,0,0.486L11.411,8.96l-0.209-0.25L11.98,8.488z M45.592,18.139h-1.779l-1.084-0.807l-1.141,0.111v0.696h-0.361    l-0.39-0.278l-1.976-0.501v-1.28l-2.504,0.195l-0.776,0.417h-0.994L34.1,16.643l-1.207,0.67v1.261l-2.467,1.78l0.205,0.76h0.5    L31,21.838l-0.352,0.129l-0.019,1.892l2.132,2.428h0.928l0.056-0.148h1.668l0.481-0.445h0.946l0.519,0.52l1.41,0.146l-0.187,1.875    l1.565,2.763l-0.824,1.575l0.056,0.742l0.649,0.647v1.784l0.852,1.146v1.482h0.736c-4.096,5.029-10.33,8.25-17.305,8.25    C12.009,46.625,2,36.615,2,24.312c0-3.097,0.636-6.049,1.781-8.732v-0.696l0.798-0.969c0.277-0.523,0.574-1.033,0.891-1.53    l0.036,0.405l-0.926,1.125c-0.287,0.542-0.555,1.096-0.798,1.665v1.27l0.927,0.446v1.765l0.889,1.517l0.723,0.111l0.093-0.52    l-0.853-1.316l-0.167-1.279h0.5l0.211,1.316l1.233,1.799L7.02,21.27l0.784,1.199l1.947,0.482v-0.315l0.779,0.111l-0.074,0.556    l0.612,0.112l0.945,0.258l1.335,1.521l1.705,0.129l0.167,1.391l-1.167,0.816l-0.055,1.242l-0.167,0.76l1.688,2.113l0.129,0.724    c0,0,0.612,0.166,0.687,0.166c0.074,0,1.372,0.983,1.372,0.983v3.819l0.463,0.13l-0.315,1.762l0.779,1.039l-0.144,1.746    l1.029,1.809l1.321,1.154l1.328,0.024l0.13-0.427l-0.976-0.822l0.056-0.408l0.175-0.5l0.037-0.51l-0.66-0.02l-0.333-0.418    l0.548-0.527l0.074-0.398l-0.612-0.175l0.036-0.37l0.872-0.132l1.326-0.637l0.445-0.816l1.391-1.78l-0.316-1.392l0.427-0.741    l1.279,0.039l0.861-0.682l0.278-2.686l0.955-1.213l0.167-0.779l-0.871-0.279l-0.575-0.943l-1.965-0.02l-1.558-0.594l-0.074-1.111    l-0.52-0.909l-1.409-0.021l-0.814-1.278l-0.723-0.353l-0.037,0.39l-1.316,0.078l-0.482-0.671l-1.373-0.279l-1.131,1.307    l-1.78-0.302l-0.129-2.006l-1.299-0.222l0.521-0.984l-0.149-0.565l-1.707,1.141l-1.074-0.131L9.48,21.016l0.234-0.865l0.592-1.091    l1.363-0.69l2.632-0.001l-0.007,0.803l0.946,0.44l-0.075-1.372l0.682-0.686l1.376-0.904l0.094-0.636l1.372-1.428l1.459-0.808    l-0.129-0.106l0.988-0.93l0.362,0.096l0.166,0.208l0.375-0.416l0.092-0.041l-0.411-0.058l-0.417-0.139v-0.4l0.221-0.181h0.487    l0.223,0.098l0.193,0.39l0.236-0.036v-0.034l0.068,0.023l0.684-0.105l0.097-0.334l0.39,0.098v0.362l-0.362,0.249h0.001    l0.053,0.397l1.239,0.382c0,0,0.001,0.005,0.003,0.015l0.285-0.024l0.019-0.537l-0.982-0.447l-0.056-0.258l0.815-0.278l0.036-0.78    l-0.852-0.519l-0.056-1.315l-1.168,0.574h-0.426l0.112-1.001l-1.59-0.375l-0.658,0.497v1.516l-1.183,0.375l-0.474,0.988    l-0.514,0.083v-1.264l-1.112-0.154l-0.556-0.362l-0.224-0.819l1.989-1.164l0.973-0.296l0.098,0.654l0.542-0.028l0.042-0.329    l0.567-0.081l0.01-0.115l-0.244-0.101l-0.056-0.348l0.697-0.059l0.421-0.438l0.023-0.032l0.005,0.002l0.128-0.132l1.465-0.185    l0.648,0.55l-1.699,0.905l2.162,0.51l0.28-0.723h0.945l0.334-0.63l-0.668-0.167V6.212L22.69,5.284l-1.446,0.167l-0.816,0.427    l0.056,1.038l-0.853-0.13L19.5,6.212l0.817-0.742l-1.483-0.074l-0.426,0.129l-0.185,0.5l0.556,0.094l-0.111,0.556l-0.945,0.056    l-0.148,0.37l-1.371,0.038c0,0-0.038-0.778-0.093-0.778c-0.055,0,1.075-0.019,1.075-0.019l0.817-0.798l-0.446-0.223l-0.593,0.576    l-0.984-0.056l-0.593-0.816h-1.261L12.81,6.008h1.206l0.11,0.353l-0.313,0.291l1.335,0.037l0.204,0.482l-1.503-0.056l-0.073-0.371    L12.831,6.54L12.33,6.262l-1.125,0.009C14.888,3.588,19.417,2,24.312,2c5.642,0,10.797,2.109,14.73,5.574l-0.265,0.474    l-1.029,0.403l-0.434,0.471l0.1,0.549l0.531,0.074l0.32,0.8l0.916-0.369l0.151,1.07h-0.276l-0.752-0.111l-0.834,0.14l-0.807,1.14    l-1.154,0.181l-0.167,0.988l0.487,0.115l-0.141,0.635l-1.146-0.23l-1.051,0.23l-0.223,0.585l0.182,1.228l0.617,0.289l1.035-0.006    l0.699-0.063l0.213-0.556l1.092-1.419l0.719,0.147l0.708-0.64l0.132,0.5l1.742,1.175l-0.213,0.286l-0.785-0.042l0.302,0.428    l0.483,0.106l0.566-0.236l-0.012-0.682l0.251-0.126l-0.202-0.214l-1.162-0.648l-0.306-0.861h0.966l0.309,0.306l0.832,0.717    l0.035,0.867l0.862,0.918l0.321-1.258l0.597-0.326l0.112,1.029l0.583,0.64l1.163-0.02c0.225,0.579,0.427,1.168,0.604,1.769    L45.592,18.139z M13.261,11.046l0.584-0.278l0.528,0.126l-0.182,0.709l-0.57,0.181L13.261,11.046z M16.36,12.715v0.459h-1.334    l-0.5-0.139l0.125-0.32l0.641-0.265h0.876v0.265H16.36z M16.974,13.355V13.8l-0.334,0.215l-0.416,0.077c0,0,0-0.667,0-0.737    H16.974z M16.598,13.174v-0.529l0.459,0.418L16.598,13.174z M16.807,14.244v0.433l-0.319,0.32h-0.709l0.111-0.486l0.335-0.029    l0.069-0.167L16.807,14.244z M15.041,13.355h0.737l-0.945,1.321l-0.39-0.209l0.084-0.556L15.041,13.355z M18.059,14.092v0.432    H17.35l-0.194-0.28v-0.402h0.056L18.059,14.092z M17.404,13.498l0.202-0.212l0.341,0.212l-0.273,0.225L17.404,13.498z     M45.954,19.265l0.07-0.082c0.029,0.126,0.06,0.252,0.088,0.38L45.954,19.265z" fill="#27bbed" data-original="#000000" style="" class=""/>
                  <path d="M3.782,14.884v0.696c0.243-0.568,0.511-1.122,0.798-1.665L3.782,14.884z" fill="#27bbed" data-original="#000000" style="" class=""/>
                </g>
              </g>
              </svg>
             &nbsp; Everyone Can reply
          </button>
        </div>
      </div>
    </div>
   
    <div class="footer">
      <button class="submit-btn" type="button" onclick="postOnTwitter()">Post To Twitter</button>
    </div>
  </div>
</div>

<script>


function postOnTwitter(){
  let newLine = document.getElementById("twitter-input").value;
  let message = document.getElementById("twiteer-message-content").innerHTML;
  let localData=JSON.parse(localStorage.getItem("enrollData"));
  message =   message.replaceAll(localData.inviteTwitterUrl,"")
  message=message.replace(/(<([^>]+)>)/ig, "").trim()+newLine;
  let haseTags = message.match(/#\w+/g);
  if(haseTags)
  haseTags = haseTags.toString();
  //let image = document.getElementById("twitter-post-image").src;
  window.open("https://twitter.com/share?text="+encodeURIComponent(message)+"&url="+localData.inviteTwitterUrl)
  closeSocialPreview('twitter-popup')
  openSocialPreview("thanks-popup")
}

</script>
`